/** sessionStorage keys `beforeunload` uses to stash where the user was, for a refresh restore. */
export const RESTORE_KEYS = {
  refreshing: 'REFRESHING',
  roomPid: 'CrtRoomPid',
  floorPid: 'CrtFloorPid',
  status: 'CrtStatus',
} as const;

export interface PendingRoomRestore {
  roomPid: string;
  floorPid: string;
}

/** Where this page load will restore the user to, or null; read-only so the restore can still use the flags. */
export function peekPendingRoomRestore(
  storage: Pick<Storage, 'getItem'> | undefined = typeof sessionStorage === 'undefined'
    ? undefined
    : sessionStorage
): PendingRoomRestore | null {
  try {
    if (!storage || storage.getItem(RESTORE_KEYS.refreshing) !== '1') return null;
    const roomPid = storage.getItem(RESTORE_KEYS.roomPid);
    const floorPid = storage.getItem(RESTORE_KEYS.floorPid);
    return roomPid && floorPid ? { roomPid, floorPid } : null;
  } catch {
    return null;
  }
}
